var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50706 5.41668C9.76678 5.41668 9.98449 5.32883 10.1602 5.15314C10.3359 4.97744 10.4237 4.75973 10.4237 4.50001C10.4237 4.24029 10.3359 4.02258 10.1602 3.84689C9.98449 3.67119 9.76678 3.58334 9.50706 3.58334C9.24734 3.58334 9.02963 3.67119 8.85394 3.84689C8.67824 4.02258 8.59039 4.24029 8.59039 4.50001C8.59039 4.75973 8.67824 4.97744 8.85394 5.15314C9.02963 5.32883 9.24734 5.41668 9.50706 5.41668ZM8.59039 12.75H10.4237V7.25001H8.59039V12.75ZM0.340393 19.1667V2.66668C0.340393 2.16251 0.519907 1.73091 0.878935 1.37189C1.23796 1.01286 1.66956 0.833344 2.17373 0.833344H16.8404C17.3446 0.833344 17.7762 1.01286 18.1352 1.37189C18.4942 1.73091 18.6737 2.16251 18.6737 2.66668V13.6667C18.6737 14.1708 18.4942 14.6024 18.1352 14.9615C17.7762 15.3205 17.3446 15.5 16.8404 15.5H4.00706L0.340393 19.1667ZM3.22789 13.6667H16.8404V2.66668H2.17373V14.6979L3.22789 13.6667Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatInfo);
export default __webpack_public_path__ + "static/media/ChatInfo.c545a30fbfd19dd20dc6635206f45f7f.svg";
export { ForwardRef as ReactComponent };